import { render, staticRenderFns } from "./faturaDuzenle.vue?vue&type=template&id=50f6db7e&scoped=true&"
import script from "./faturaDuzenle.vue?vue&type=script&lang=js&"
export * from "./faturaDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./faturaDuzenle.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./faturaDuzenle.vue?vue&type=style&index=1&id=50f6db7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6db7e",
  null
  
)

export default component.exports